import React, { useCallback, useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import {
  callActionApiAsync,
  getBiomedicalLocationEquipmentSummary,
  putUpdateBiomedicalUbication
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const validationSchema = yup.object().shape({
  name: yup.string().required("Este campo es obligatorio")
});

const EditLocationModal = ({
  open,
  close,
  locationRow,
  onSaved,
  userId
}) => {
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warning",
    summary: "",
    detail: ""
  });
  const [equipmentCount, setEquipmentCount] = useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { name: "" }
  });

  const loadEquipmentCount = useCallback(async () => {
    const lid = locationRow?.value;
    if (lid == null || lid === "" || !userId) {
      setEquipmentCount(null);
      return;
    }
    setSummaryLoading(true);
    try {
      const { data } = await getBiomedicalLocationEquipmentSummary(lid, userId);
      setEquipmentCount(
        typeof data?.count === "number" ? data.count : (data?.equipment?.length ?? 0)
      );
    } catch {
      setEquipmentCount(null);
    } finally {
      setSummaryLoading(false);
    }
  }, [locationRow?.value, userId]);

  useEffect(() => {
    if (open && locationRow) {
      reset({ name: locationRow.name || "" });
      loadEquipmentCount();
    } else if (open && !locationRow) {
      reset({ name: "" });
      setEquipmentCount(null);
    } else if (!open) {
      setEquipmentCount(null);
    }
  }, [open, locationRow, reset, loadEquipmentCount]);

  const handleClose = () => {
    reset();
    setEquipmentCount(null);
    close();
  };

  const onSubmit = async (formData) => {
    if (!locationRow?.value) return;
    await callActionApiAsync(
      () =>
        putUpdateBiomedicalUbication({
          id: locationRow.value,
          name: formData.name,
          userId
        }),
      () => {
        onSaved?.();
        handleClose();
      },
      (err) => {
        const detail =
          typeof err === "string" && err
            ? err
            : "No se pudo actualizar la ubicación.";
        setToastConfig({
          severity: "error",
          summary: "Error",
          detail
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Editar ubicación"
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <div className="HContainer">
          <form
            className="VContainer align-center m-20"
            onSubmit={handleSubmit(onSubmit)}
            style={{ maxWidth: "420px" }}
          >
            {summaryLoading && (
              <p className="mb-12" style={{ fontSize: "14px", color: "#666" }}>
                Comprobando equipos vinculados…
              </p>
            )}
            {!summaryLoading && equipmentCount != null && equipmentCount > 0 && (
              <div
                className="mb-15"
                style={{
                  padding: "10px 12px",
                  fontSize: "14px",
                  lineHeight: 1.45,
                  background: "#e3f2fd",
                  borderRadius: "8px",
                  border: "1px solid #90caf9"
                }}
                role="status"
              >
                Está modificando la ubicación usada por{" "}
                <strong>{equipmentCount}</strong> equipo(s) biomédico(s). El
                nombre nuevo se reflejará en todos ellos.
              </div>
            )}
            {!summaryLoading && equipmentCount === 0 && (
              <div
                className="mb-15"
                style={{
                  padding: "10px 12px",
                  fontSize: "14px",
                  lineHeight: 1.45,
                  background: "#f5f5f5",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0"
                }}
                role="status"
              >
                Esta ubicación no tiene equipos biomédicos asignados en este
                momento.
              </div>
            )}
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <p className="create-label">Nombre de la ubicación:</p>
                <FormTextField
                  name="name"
                  control={control}
                  error={errors.name}
                />
              </Grid>
              <Grid item xs={12} className="HContainer j-center">
                <LaddaButton type="submit" variant="contained">
                  Guardar
                </LaddaButton>
              </Grid>
            </Grid>
          </form>
        </div>
      </ModalComponent>
      <ToastNotification
        showToast={showToast}
        setShowToast={setShowToast}
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
      />
    </>
  );
};

export default EditLocationModal;
